import React, {Component} from 'react';
import {BrowserRouter, Switch} from 'react-router-dom';
import {connect} from 'react-redux';

import {allFlattenRoutes as routes} from './index';
import {isUserAuthenticated} from '../helpers/authUtils';
import * as layoutConstants from '../constants/layout';

// All layouts/containers
import AuthLayout from '../layouts/Auth';
import VerticalLayout from '../layouts/Vertical';
import HorizontalLayout from '../layouts/Horizontal';
import DetachedLayout from '../layouts/Detached';
import {SERVER_FOLDER_AS_BASE_PATH} from "../env";
import PublicLayout from "../layouts/Public";


class Routes extends Component {
    // returns the layout
    getLayout = () => {

        // caso eccezionale per la PrivacyPolicy
        if( window.location.href.indexOf("/privacy-policy") !== -1 ) return PublicLayout;
        // caso eccezionale per la CookiePolicy
        if( window.location.href.indexOf("/cookie-policy") !== -1 ) return PublicLayout;

        // autenticazione con Microsoft Entra
        if( window.location.href.indexOf("/authenticateSpoiler") !== -1 ) return PublicLayout;

        if (!isUserAuthenticated() && window.location.href.indexOf("/public/") === -1) return AuthLayout;
        if( window.location.href.indexOf("/public/") !== -1 ) return PublicLayout;

        let layoutCls = VerticalLayout;

        switch (this.props.layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case layoutConstants.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };

    shouldComponentUpdate(nextProps, nextState) {
        let oldLayout = { ...this.props.layout };
        delete oldLayout.showRightSidebar;
        let newLayout = { ...nextProps.layout };
        delete newLayout.showRightSidebar;
        return (
            JSON.stringify(oldLayout) !== JSON.stringify(newLayout) ||
            JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user)
        );
    }

    render() {

        // showlog("controllo isSRTool", (window.location.href.toLowerCase().trim().indexOf("srtool") !== -1));

        const Layout = this.getLayout();
        // rendering the router with layout
        return (
            <BrowserRouter basename={ SERVER_FOLDER_AS_BASE_PATH }>
                <Layout {...this.props} isSRTool={(window.location.href.toLowerCase().trim().indexOf("srtool") !== -1)}>
                    <Switch>
                        {
                            routes.map((route, index) => {
                                return (
                                    !route.children && (
                                        <route.route
                                            key={index}
                                            path={route.path}
                                            roles={route.roles}
                                            exact={route.exact}
                                            component={route.component}
                                            // onComponentDidMount={route.callBack}
                                            // isSRTool={(window.location.href.toLowerCase().trim().indexOf("srtool") !== -1)}
                                        />
                                    )
                                );
                            })
                        }
                    </Switch>
                </Layout>
            </BrowserRouter>
        );
    }



}

const mapStateToProps = state => {
    return {
        layout: state.Layout,
        user: state.Auth.user,
    };
};

export default connect(
    mapStateToProps,
    null
)(Routes);
